export const services = [
  { title: "Mikrojehličkování" },
  { title: "Hydrafacial, dermabraze" },
  { title: "BB Glow" },
  { title: "Rty, Hyaluron" },
  { title: "Konturace obličeje" },
  { title: "Permanentní makeup obočí" },
  { title: "Permanentní make-up rtů" },
  { title: "Permanentní make-up očních linek" },
  { title: "Prodlužování Řas" },
  { title: "Chemický Peeling/Biorepeel" },
  { title: "Inovativní ošetření očního okolí" },
  { title: "Anti Age, odbourání známek stárnutí" },
  { title: "Ošetření pleti- čištění, péče dle typu pleti" },
  { title: "Laminace obočí" },
  { title: "Laminace řas" },
  { title: "Barvení obočí nebo řas s úpravou" },
  { title: "Pedikúra" },
];
